import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import TeamItem from "../components/TeamItem";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";

function AllTeams() {
  const {
    user,
    setPending,
    backendURL,
    setAlertMessage,
    setIsErr,
    setShowAlert,
  } = useContext(PitchContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [allTeams, setAllTeams] = useState([]);
  const [filteredTeams, setFilteredTeams] = useState([]);

  // Fetch all teams from backend
  const getAllTeams = () => {
    setPending(true);
    axios
      .get(backendURL + "team/get")
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setAllTeams(response.data.teams);
          setFilteredTeams(response.data.teams); // Initialize with all teams
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response?.data?.message || "An error occurred");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    getAllTeams();
  }, []);

  // Update filtered teams when search term changes
  useEffect(() => {
    if (!searchTerm) {
      setFilteredTeams(allTeams);
    } else {
      const lowerCasedTerm = searchTerm.toLowerCase();
      const filtered = allTeams.filter(
        (team) =>
          team.name.toLowerCase().includes(lowerCasedTerm) ||
          team.city.toLowerCase().includes(lowerCasedTerm)
      );
      setFilteredTeams(filtered);
    }
  }, [searchTerm, allTeams]);

  return (
    <div className="my-10 px-4 relative">
      {/* Header with Title and Profile Picture */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Takımlar</h1>
      </div>

      {/* Search Input with Plus Button */}
      <div className="mb-6 flex items-center gap-4 max-w-3xl mx-auto">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="İsim veya şehir ile takım ara..."
          className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-[#4d9041]"
        />
        {user && user.team ? (
          <img
            className="w-9 h-9 rounded-full object-cover ring-2 ring-[#4d9041]/20 hover:ring-[#4d9041] transition-all duration-300"
            src={user.team.image}
            alt="Profil"
          />
        ) : (
          <Link to={user ? "/takim-ekle" : "/giris-yap"}>
            <button className="p-3 bg-[#4d9041] text-white rounded-lg hover:bg-[#62a556] transition-colors cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </button>
          </Link>
        )}
      </div>

      {/* Teams Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredTeams?.length > 0 ? (
          filteredTeams?.map((team, index) => (
            <TeamItem key={index} team={team} />
          ))
        ) : allTeams?.length === 0 ? (
          <p className="text-center text-gray-600 col-span-full">
            Henüz takım yok.
          </p>
        ) : (
          <p className="text-center text-gray-600 col-span-full">
            Aramanızla eşleşen takım bulunamadı.
          </p>
        )}
      </div>
    </div>
  );
}

export default AllTeams;
